module.exports = __webpack_public_path__ + "static/media/profile-picture-1.508e07ee.jpg";